import React from 'react';

import { Radio } from '@mui/material';

import { money } from '../../../utils';

const columnClassName = 'align-middle text-nowrap';

export const checkColumnsSingle = (t, selectedRow, setSelectedRow) => [
  {
    id: 'select',
    Cell: ({ row }) => <SingleRadio selectedRow={selectedRow} setSelectedRow={setSelectedRow} row={row} />,
  },
  {
    Header: `${t('edge_reporting.check_pdf.associate')} Number`,
    accessor: 'Employee_ID',
    className: columnClassName,
  },
  {
    Header: `${t('edge_reporting.check_pdf.associate')} Name`,
    accessor: 'Employee_Name',
    className: columnClassName,
  },
  {
    Header: 'Check #',
    accessor: 'Check_ID',
    className: columnClassName,
  },
  {
    Header: 'Check Date',
    accessor: 'Check_Date',
    className: columnClassName,
  },
  {
    Header: 'Gross Pay',
    accessor: 'Gross_Wages',
    className: columnClassName,
    Cell: instance => money.format(instance.value),
  },
  {
    Header: 'Net Pay',
    accessor: 'Net_Wages',
    className: columnClassName,
    Cell: instance => money.format(instance.value),
  },
  {
    Header: 'Period End Date',
    accessor: 'Period_Ending_Date',
    className: columnClassName,
  },
  {
    Header: 'VOID',
    accessor: 'Void',
    className: columnClassName,
    Cell: instance => (instance.value ? 'Yes' : 'No'),
  },
];

export const checkColumns = t => [
  {
    Header: `${t('edge_reporting.check_pdf.associate')} Number`,
    accessor: 'Employee_ID',
    className: columnClassName,
  },
  {
    Header: `${t('edge_reporting.check_pdf.associate')} Name`,
    accessor: 'Employee_Name',
    className: columnClassName,
  },
  {
    Header: 'Check #',
    accessor: 'Check_ID',
    className: columnClassName,
  },
  {
    Header: 'Check Date',
    accessor: 'Check_Date',
    className: columnClassName,
  },
  {
    Header: 'Gross Pay',
    accessor: 'Gross_Wages',
    className: columnClassName,
  },
  {
    Header: 'Net Pay',
    accessor: 'Net_Wages',
    className: columnClassName,
  },
  {
    Header: 'Period End Date',
    accessor: 'Period_Ending_Date',
    className: columnClassName,
  },
  {
    Header: 'VOID',
    accessor: 'Void',
    className: columnClassName,
    Cell: instance => (instance.value ? 'Yes' : 'No'),
  },
  {
    Header: 'Customer Number',
    accessor: 'Client_Id',
    className: columnClassName,
  },
  {
    Header: 'Customer Name',
    accessor: 'Client_Name',
    className: columnClassName,
  },
  {
    Header: 'Job',
    accessor: 'Job_id',
    className: columnClassName,
  },
  {
    Header: 'Type',
    accessor: 'Pay_Code',
    className: columnClassName,
  },
  {
    Header: 'Description',
    accessor: 'Pay_Code_Description',
    className: columnClassName,
  },
  {
    Header: 'Hours',
    accessor: 'Pay_Hours',
    className: columnClassName,
  },
  {
    Header: 'Rate',
    accessor: 'Pay_Rate',
    className: columnClassName,
  },
  {
    Header: 'Amount',
    accessor: 'Pay_Amount',
    className: columnClassName,
  },
];

const SingleRadio = ({ selectedRow, setSelectedRow, row }) => (
  <div className="px-1">
    <Radio
      style={{
        transform: 'scale(1)',
      }}
      className="radio-button"
      onChange={() => setSelectedRow(row.id)}
      checked={selectedRow === row.id}
    />
  </div>
);
